export enum AdministrationRouteEnum {
  Inhalation = 1,// - інгаляційне;
  Oral = 2,// - пероральне;
  Intravascular = 3,// - внутрішньосудинне;
  Intramuscular = 4,// - внутрішньомʼязове;
  Other = 5,// - інше;
}
